export default "__VITE_ASSET__Cun81fo2__"